import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { History } from "lucide-react";

const fmt = (iso) => { try { return new Date(iso).toLocaleString(); } catch { return iso; } };

export const AuditLogCard = () => {
  const [data, setData] = useState(null);
  const [skip, setSkip] = useState(0);
  const limit = 25;
  useEffect(() => { api.get(`/admin/audit-log?limit=${limit}&skip=${skip}`).then((r) => setData(r.data)).catch(() => {}); }, [skip]);
  if (!data) return null;

  return (
    <Card className="p-6 border-slate-200" data-testid="audit-log-card">
      <div className="flex items-center gap-2"><History className="h-4 w-4 text-[#2563EB]" /><h3 className="text-sm font-semibold text-slate-900">Security &amp; Access Audit Log</h3><Badge variant="outline" className="text-[10px]">{data.total}</Badge></div>
      <p className="text-xs text-slate-500 mt-1">Account, workspace, project and privacy events for this workspace only. No passwords or tokens are stored.</p>
      <div className="mt-4 divide-y divide-slate-100 max-h-96 overflow-auto">
        {data.rows.length === 0 && <p className="text-sm text-slate-400 py-3">No events yet.</p>}
        {data.rows.map((r, i) => (
          <div key={i} className="py-2 flex items-center gap-3 text-xs" data-testid="audit-row">
            <span className="font-mono text-[11px] text-slate-400 w-36 shrink-0">{fmt(r.at)}</span>
            <Badge className="bg-slate-100 text-slate-700 capitalize shrink-0">{(r.action || "").replace(/_/g, " ")}</Badge>
            <span className="text-slate-600 truncate">{r.user_name || r.user_id}{r.meta && Object.keys(r.meta).length ? ` · ${Object.entries(r.meta).map(([k, v]) => `${k}=${v}`).join(", ")}` : ""}</span>
          </div>
        ))}
      </div>
      <div className="mt-3 flex items-center justify-between">
        <Button variant="outline" size="sm" disabled={skip === 0} onClick={() => setSkip(Math.max(0, skip - limit))} data-testid="audit-prev">Previous</Button>
        <span className="text-xs text-slate-400">{skip + 1}–{Math.min(skip + limit, data.total)} of {data.total}</span>
        <Button variant="outline" size="sm" disabled={skip + limit >= data.total} onClick={() => setSkip(skip + limit)} data-testid="audit-next">Next</Button>
      </div>
    </Card>
  );
};
